import React from 'react';
import { TitleHeader } from 'web-library';
import CoordinatorResitRoute from '../../modules/resit/components/@coordinator/CoordinatorResitRoute';

interface CoordinatorResitFlowProps {
  title: string;
}

const CoordinatorResitFlow = ({ title = '' }: CoordinatorResitFlowProps) => (
  <>
    <TitleHeader title={title} />

    <CoordinatorResitRoute />
  </>
);

export default CoordinatorResitFlow;
